<template>
    <v-app id="app">
      <div  id="mobile-version">

        <div style="width: 100%; height: 35%; display: flex; justify-content: center; align-items: center">

          <v-icon color="white" style="font-size: 35vw!important; margin-top: 15%">
            fas fa-exclamation-triangle
          </v-icon>

        </div>

        <div style="width: 100%; height: 55%; color: white; padding-left: 10%; padding-right: 10%; display: flex; justify-content: center; align-items: center">

          <div>
          <b style="font-size: 6vw">This service has now closed</b>
            <p style="font-size: 4vw">For more information please call <b>1300024400</b> for more information</p>
          </div>


        </div>

        <div style="width: 70%; height: 10%; margin-left: auto; margin-right: auto">
          <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGirlTextLogo}"></div>
          <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedChatTubeLogo}"></div>
          <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedBabeFlirtLogo}"></div>
          <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGayTextLogo}"></div>
        </div>





      </div>
      <div id="display-version">

        <div style="width: 100%; height: 20%; display: flex; justify-content: center; align-items: center; padding-top: 7.5%">


        </div>

        <div style="width: 100%; height: 55%; display: flex; justify-content: center; align-items: center; color: white; padding-right: 10%; padding-left: 10%">

          <div>
            <b style="font-size: 4vw">This service has now closed</b>
            <p style="font-size: 2vw">For more information please call <b>1300024400</b> for more information</p>
          </div>


        </div>

        <div style="width: 50%; height: 10%; margin-left: auto; margin-right: auto">
          <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGirlTextLogo}"></div>
          <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedChatTubeLogo}"></div>
          <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedBabeFlirtLogo}"></div>
          <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGayTextLogo}"></div>
        </div>

        <div style="width: 100%; height: 15%">
          <div style="height: 30%; width: 100%; color: white; font-size: 0.75vw; display: flex; justify-content: center; align-items: center; padding-right: 10%; padding-left: 10%">
            You must be 18+ and be the bill payer or have the bill payers permission to use this service. To stop all messages text STOP to 85722. Costs are plus your standard network charge. You will receive free marketing messages by signing up to this service, text XSTOP to 85722 at any time to opt out. Service Provided by All Points North Publications Ltd, LS1 6ER. Customer Service: 03303330320
          </div>

          <div style="height: 30%; width: 100%; color: white; font-size: 0.75vw; display: flex; justify-content: center; align-items: center; padding-right: 10%; padding-left: 10%">
            Copyright © 2019 - 2020 All Points North Publications . All rights reserved.
          </div>

          <div style="height: 25%; width: 100%; display: flex; justify-content: center; align-items: center;">
            <v-avatar size="25%" style="height: auto; max-width: 100%;" tile>
              <img
                  :src="logoVisa"
                  alt="Visa Verified"
              >
            </v-avatar>
          </div>

        </div>



      </div>





    </v-app>

</template>

<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default {
  components: {

  },

  data () {
    return {

      logoVisa: require('@/images/logos/visa.png'),
      logoChatTube: require('@/images/logos/chatTube.png'),
      logoBabeFlirt: require('@/images/logos/babeflirt.png'),
      logoGayTxt: require('@/images/logos/gayText.png'),
      logoGirlTxtW: require('@/images/logos/girlTextW.png'),

      // Dynamic Size End
    }
  },
  watch: {

  },
  mounted: function () {

    document.title = 'Chattube - Australia' // Assigns document title

  },

  computed: {
    // Computes Chat Tube Logo
    computedChatTubeLogo: function () {
      this.logoChatTube = 'url(' + this.logoChatTube + ')'
      return this.logoChatTube
    },
    // Computes Girl Text Logo
    computedGirlTextLogo: function () {
      this.logoGirlTxtW = 'url(' + this.logoGirlTxtW + ')'
      return this.logoGirlTxtW
    },

    // Computes Babe Flirt Logo
    computedBabeFlirtLogo: function () {
      this.logoBabeFlirt = 'url(' + this.logoBabeFlirt + ')'
      return this.logoBabeFlirt
    },

    // Computes gay Text Logo
    computedGayTextLogo: function () {
      this.logoGayTxt = 'url(' + this.logoGayTxt + ')'
      return this.logoGayTxt
    },

    // Computes The height of the card
    computedHeight: function () {
      return this.height
    },
    // Computes The width of the card
    computedWidth: function () {
      return this.width
    }
  },
  methods: {
  },
  created () {
    document.write('<meta name="viewport" content="width=device-width,height=' + window.innerHeight + ', initial-scale=1.0">')
    document.write('<meta name="theme-color" content="#050505">')
    document.write('<meta name="apple-mobile-web-app-capable" content="yes">')
    document.write('<meta name="apple-mobile-web-app-status-bar-style" content="black">')

  }
}
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
        color: black;
        background: black;
    }

    #app {
        width: 100%;
        height: 100%;

    }

    #container-area {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-image: url("../../images/backgrounds/babeflirtM.jpg");
        width: 100%;
        height: 100%;
        background-size: cover;
    }


    @media only screen and (min-width: 768px) {
        #mobile-version {
            width: 100%;
            height: 100%;
            display: none;
        }
        #display-version {
            width: 100%;
            height: 100%;
            background-image: url("../../images/backgrounds/babeflirtD.jpg");
            background-size: cover;
        }
        #cont-btn3 {
            font-size: 2.5vh;
            border-radius: 5px;
            color: white
        }

      .logo-image-holder {

        width: 25%;
        height: 100%;
        float: left;
        background-size: 70%;
        background-position: center;

      }

    }



    @media only screen and (max-width: 768px) {
        #mobile-version {
            width: 100%;
            height: 100%;
          background-image: url("../../images/backgrounds/babeflirtM.jpg");
          background-size: cover;
        }
        #display-version {
            display: none;
        }

      .logo-image-holder {

        width: 25%;
        height: 100%;
        float: left;
        background-size: 100%;
        background-position: center;

      }

        #user-info-section {
            height: 100%;
            width: 100%;
        }

        #manual-stepper {
            font-family: 'Avenir', Helvetica, Arial, sans-serif;
            text-align: center;
            color: black;
            /*background-image: url("../../../images/backgrounds/babeflirtM.jpg");*/
            background: linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 59%, rgba(0, 0, 0, 0.75) 100%), url('../../images/backgrounds/babeflirtM.jpg') no-repeat;;
            width: 100%;
            height: 95%;
            background-size: cover;

        }

        #manual-stepper-header {
            width: 50%;
            height: 10%;
            margin-right: auto;
            margin-left: auto;
            box-shadow: none;
            border-radius: 20px;
        }

        #manual-stepper-items {

            height: 93%;
            width: 100%;

        }

        .stepper-content {

        }

        .item-content {
            padding: 5%;

        }

        .item-container {
            background-color: white;
            height: 100%;
            width: 100%;
            border-radius: 5px;
        }

        /*NEEDED FOR VUE*/
        .v-stepper__wrapper {
            height: 100%;

        }

        /*NEEDED FOR VUE*/
        .v-stepper__content {
            padding: 0;
            height: 100%;
        }

        .container-top {
            width: 100%;
            height: 20%;

            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            font-size: 3vh;
            color: rgba(0, 0, 0, 0.5);
        }

        .container-middle {
            width: 100%;
            height: 60%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;

        }

        .container-middle-telephone {
            width: 100%;
            height: 60%;
            font-weight: bold;

        }

        .container-bottom {
            width: 100%;
            height: 20%;

        }

        #cont-btn {
            font-size: 3.5vw;
            border-radius: 5px;
            color: white
        }

        #cont-btn2 {
            font-size: 3.5vw;
            border-radius: 5px;
            color: white
        }

        #telephone-input {

            height: 40%;
            width: 80%;
            border-style: solid;
            border-radius: 10px;
            font-size: 6vw;
            color: rgba(0, 0, 0, 0.7);
            text-align: center;

        }

        ::placeholder {
            color: rgba(0, 0, 0, 0.45);
            opacity: 1; /* Firefox */
        }

        #character-info {

            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 2.5vw;
            padding-bottom: 1vw;
            color: rgba(0, 0, 0, 0.6);
        }

        #logo-area {
            width: 100%;
            height: 5%;
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-left: 2.5%;
            padding-right: 2.5%;

        }

        #cookie-overlay-main {
            height: 70vh;
            width: 80vw;
            background-color: white;
            border-radius: 5px
        }

        #cookie-header {
            height: 40%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center
        }

        #cookie-info-content {
            height: 40%;
            width: 100%;
            color: black
        }

        #cookie-info-header {
            height: 40%;
            width: 100%;
            font-weight: bold;
            font-size: 6vw
        }

        #cookie-icon {

            font-size: 17.5vh;
            color: black;

        }

        #cookie-info-more {
            height: 10%;
            width: 100%;
            font-size: 4vw;
        }

        #cookie-info-more-button {
            color: black;
            text-decoration: underline;
            font-size: 3vw;
            font-weight: bold
        }

        #cookie-info-disclaimer {
            height: 40%;
            width: 100%;
            font-size: 4vw;
            padding-left: 5%;
            padding-right: 5%;
        }

        #cookie-accept {
            height: 20%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center
        }

        #cookie-accept-button {
            font-size: 3vw;
        }

    }

</style>
